import React, { Suspense, useEffect, useState } from "react";
import { Error } from "../../../commons/Messages/Messages";
import axios from "axios";
import { isAuthenticated } from "../../../commons/Auth/auth";
import OffersList from "../../../commons/Billing/Offers/OffersList";
import AddOffers from "../../../commons/Billing/Offers/AddOffers";
import SearchBarComp from "../../../commons/SearchBar/SearchBar";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { useTranslation } from "react-i18next";
import PageToolbar from "../../../design-system/PageToolbar";
import GaebImport from "../gaeb/GaebImport";
import { useHistory, useLocation } from "react-router-dom";

const Offers = () => {
  const { t } = useTranslation("dashboard");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(15);
  const [searchText, setSearchText] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [data, setData] = useState([]);
  const location = useLocation();
  const history = useHistory();
  // /user/offers?open=<id> (links from the assistant) opens that offer's form
  const openId = new URLSearchParams(location.search).get("open");
  const [openOffer, setOpenOffer] = useState(null);

  useEffect(() => {
    if (!openId) return setOpenOffer(null);
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/quotations/${openId}`, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      })
      .then(res => setOpenOffer(res.data))
      .catch(err => {
        generalErrorAlert(err);
        history.replace("/user/offers");
      });
  }, [openId]);

  const getData = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/quotations/filters`,
        {
          serviceProvider: isAuthenticated()?.serviceProviderId,
          searchText,
          pageSize,
          pageNo: pageNo - 1
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      );
      if (res.status === 200) {
        setData(res.data.data);
        setTotalCount(res.data.count);
      } else {
        Error(res.data.errorMessage);
      }
    } catch (err) {
      generalErrorAlert(err);
    }
  };

  useEffect(() => {
    getData();
  }, [searchText, pageNo]);

  const handleSearch = value => {
    setSearchText(value);
    setPageNo(1);
  };

  return (
    <div className="offers-page">
      <PageToolbar
        filters={<SearchBarComp handleSearch={handleSearch} />}
        actions={
          <Suspense fallback={<div>{t("Loading...")}</div>}>
            <GaebImport updateParent={getData} />
            <AddOffers updateParent={getData} />
          </Suspense>
        }
      />
      {openOffer && (
        <AddOffers
          data={openOffer}
          isUpdate
          autoOpen
          updateParent={getData}
          onClose={() => history.replace("/user/offers")}
        />
      )}
      <OffersList
        totalCount={totalCount}
        data={data}
        updateParent={getData}
        pageNo={pageNo}
        setPageNo={setPageNo}
        pageSize={pageSize}
      />
    </div>
  );
};

export default Offers;
